import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const categoriesInitialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const ordVolunteerListingsInitialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const volunteerListingsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.VOLUNTEER_LISTING_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.VOLUNTEER_LISTING_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.VOLUNTEER_LISTING_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.VOLUNTEER_LISTINGS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_LISTINGS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_LISTINGS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.VOLUNTEER_LISTING_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_LISTING_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_LISTING_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const volunteerListingReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.VOLUNTEER_LISTING_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.VOLUNTEER_LISTING_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.VOLUNTEER_LISTING_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const volunteerCategoriesReducer = (state = categoriesInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.CATEGORIES_READ_BEGIN:
      return {
        ...categoriesInitialState,
        loading: true,
      };

    case actions.CATEGORIES_READ_SUCCESS:
      return {
        ...categoriesInitialState,
        data,
        error: false,
        loading: false,
      };

    case actions.CATEGORIES_READ_ERR:
      return {
        ...categoriesInitialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const orgVolunteerListingsReducer = (state = ordVolunteerListingsInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ORG_VOLUNTEER_LISTINGS_READ_BEGIN:
      return {
        ...ordVolunteerListingsInitialState,
        loading: true,
      };

    case actions.ORG_VOLUNTEER_LISTINGS_READ_SUCCESS:
      return {
        ...ordVolunteerListingsInitialState,
        data,
        error: false,
        loading: false,
      };

    case actions.ORG_VOLUNTEER_LISTINGS_READ_ERR:
      return {
        ...ordVolunteerListingsInitialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { 
  volunteerListingsReducer, 
  volunteerListingReducer, 
  volunteerCategoriesReducer,
  orgVolunteerListingsReducer 
};
